module.exports = __webpack_public_path__ + "static/media/hera-512.61696d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hera-512.png
// module id = 770
// module chunks = 0